import {z} from 'zod';
import {
	editRemovesFromFilter,
	type EditRemovesFromFilterParams,
	getDefaultFilters,
	type GetDefaultFiltersParams,
	makeOptionalPropsNullable,
} from '@netx/core-schema';
import {
	AttributeVocabularyValueField,
	type IAttributeVocabularyValue,
	AttributeVocabularyValueSchema,
} from './attributeVocabularyValueSchema';

export const AttributeVocabularyValueFilterSchema = makeOptionalPropsNullable(
	AttributeVocabularyValueSchema.partial().pick({
		[AttributeVocabularyValueField.value]: true,
	}),
);

export const AttributeVocabularyValueFilterableField =
	AttributeVocabularyValueFilterSchema.keyof().enum;

export const ATTRIBUTE_VOCABULARY_VALUE_FILTERABLE_FIELDS = Object.values(
	AttributeVocabularyValueFilterableField,
);

export type AttributeVocabularyValueFilter = z.infer<
	typeof AttributeVocabularyValueFilterSchema
>;

/** will return the filters passed in if valid/specified, otherwise will return the defaults for the invalid/unspecified */
export const getAttributeVocabularyValueDefaultFilters = (
	params?: Omit<
		GetDefaultFiltersParams<AttributeVocabularyValueFilter>,
		'filterableFields'
	>,
): AttributeVocabularyValueFilter =>
	getDefaultFilters({
		...params,
		filterableFields: ATTRIBUTE_VOCABULARY_VALUE_FILTERABLE_FIELDS,
	});

/** given the original data, the new data, and the current filters, determine if the record should still be included in the filtered list */
export const attributeVocabularyValueEditRemovesFromFilter = (
	params: Omit<
		EditRemovesFromFilterParams<
			IAttributeVocabularyValue,
			AttributeVocabularyValueFilter
		>,
		'schema'
	>,
) =>
	editRemovesFromFilter({
		...params,
		schema: AttributeVocabularyValueSchema,
	});
